const PreviewOptionRow = ({ Icon, title, onClick, disabled = false }) => (
    <button type='button' className='previewInfoOptionsRow' onClick={onClick} disabled={disabled}>
        <span className='previewInfoOptionsRowMain'>
            <Icon className='previewInfoOptionsRowIcon' aria-hidden='true' />
            <span>{title}</span>
        </span>
    </button>
);

export default PreviewOptionRow;
